export default __webpack_public_path__ + "899a0577315c967d6ad85e6b8ccb55b0.png";